import Col from 'client/components/Col';
import Container from 'client/components/Container';
import React from 'react';
import Row from 'client/components/Row';
import { Heading } from '@indeed/ifl-components';

export const ApplicationError = (): JSX.Element => (
    <main>
        <Container>
            <Row>
                <Col>
                    <Heading level={4}>
                        <strong>An error has occurred.</strong>
                    </Heading>
                </Col>
            </Row>
            <Row>
                <Col>Please come back and try again later.</Col>
            </Row>
        </Container>
    </main>
);

export default ApplicationError;
